import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-seo-course-page-faq-create",
  templateUrl: "./seo-course-page-faq-create.component.html",
  styleUrls: ["./seo-course-page-faq-create.component.scss"]
})
export class SeoCoursePageFaqCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;
  pages = [];

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      // console.log(`${id}`);
      this.http
        .get<any>(this.api_endpoint + "/seocoursepagefaqbyid/" + `${id}`)
        .subscribe(
          (data) => {
            // console.log(data.data);
            if (data.data != null) {
              this.action = "Update";
              this.Form.patchValue({
                _id: data.data._id,
                question: data.data.question,
                answer: data.data.answer,
                url: data.data.url,
                seohidden: data.data.seohidden
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    });

    this.Form = this.formBuilder.group({
      question: ["", Validators.required],
      url: ["", Validators.required],
      answer: ["", Validators.required],
      _id: [""],
      seohidden: ['']
    });

    this.http.get<any>(this.api_endpoint + "/seocources/").subscribe(
      (data) => {
        this.pages = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      }
    );
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    var data = {
      question: this.Form.value.question,
      answer: this.Form.value.answer,
      url: this.Form.value.url,
      _id: this.Form.value._id,
      seohidden: this.Form.value.seohidden
    };
    if (this.action == "Submit") {
      delete data._id;
      this.http
        .post<any>(this.api_endpoint + "/seocoursepagefaq", data)
        .subscribe(
          (res) => {
            console.log(res);
            if (res.Error) {
              this.message = res.Error;
              this.class = "btn btn-primary";
              return;
            } else {
              this.message = "Successfully Added";
              this.class = "btn btn-success";
            }
            this.router.navigateByUrl(
              "/adminhkbkcms/seo-course-page-faq/list-page"
            );
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured." + err);
            }
          }
        );
    } else {
      this.http
        .put<any>(this.api_endpoint + "/seocoursepagefaq/", data)
        .subscribe(
          (res) => {
            console.log(res);
            if (res.Error) {
              this.message = res.Error;
              this.class = "btn btn-primary";
              return;
            } else {
              this.message = "Successfully Added";
              this.class = "btn btn-success";
            }
            this.router.navigateByUrl(
              "/adminhkbkcms/seo-course-page-faq/list-page"
            );
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
}
